export default "__VITE_ASSET__BOtIIRy2__"